export default {"src":"/_next/static/media/404-image.3a8df658.svg","height":325,"width":386,"blurWidth":0,"blurHeight":0};